import { render, staticRenderFns } from "./ModalConnect.vue?vue&type=template&id=64b5c0df&scoped=true&"
import script from "./ModalConnect.vue?vue&type=script&lang=js&"
export * from "./ModalConnect.vue?vue&type=script&lang=js&"
import style0 from "./ModalConnect.vue?vue&type=style&index=0&id=64b5c0df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b5c0df",
  null
  
)

export default component.exports